module.exports = {
    PUMAS_USER_PAGE_V5_FIRST_STEP: 3218, // Might replace this once test is opened
    FOXES_CREATE_BRIEF: 3253,
    PUMAS_NOTABLE_CLIENTS_SELLER_PAGE: 3267
};
